import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../hooks/useHttp";

export const getAllServices = createAsyncThunk("services/getAll", async () => {
  const { request } = useHttp();
  return await request({
    url: "/blog/service/list/",
  });
});
